const MEDIA = 'img, video, picture, svg image';

const isMedia = (event) => {
  const matches = (node) => node instanceof Element && node.matches(MEDIA);
  if (event.composedPath().some(matches)) return true;
  if (!event.clientX && !event.clientY) return false;
  const { clientX: x, clientY: y } = event;
  if (document.elementsFromPoint(x, y).some(matches)) return true;

  return Array.from(document.querySelectorAll('video')).some((video) => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  });
};

const block = (event) => {
  if (isMedia(event)) event.preventDefault();
};

window.addEventListener('contextmenu', block, { capture: true });
window.addEventListener('dragstart', block, { capture: true });

const guardVideo = (video) => {
  video.setAttribute('controlslist', 'nodownload');
  video.disablePictureInPicture = true;
};

document.querySelectorAll('video').forEach(guardVideo);

new MutationObserver((mutations) => {
  mutations.forEach((mutation) =>
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches('video')) guardVideo(node);
      node.querySelectorAll?.('video').forEach(guardVideo);
    })
  );
}).observe(document.documentElement, { childList: true, subtree: true });
